import React from 'react';
import { CheckCircle2, ArrowRight, Leaf } from 'lucide-react';
import { aboutFeatures } from '../mock';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-2 gap-14 items-center">
        <div className="relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl shadow-emerald-100">
            <img src="https://images.pexels.com/photos/9799743/pexels-photo-9799743.jpeg"
                 alt="Clean fuel facility" className="w-full h-[520px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#0b1a1a]/40 via-transparent to-transparent" />
          </div>
          {/* badge */}
          <div className="absolute -bottom-6 -left-2 lg:-left-8 bg-white rounded-2xl shadow-xl p-6 flex items-center gap-4 border border-slate-100">
            <div className="text-5xl font-extrabold text-emerald-600 leading-none">12<span className="text-3xl">+</span></div>
            <div className="text-xs uppercase font-bold text-slate-600 leading-tight">Years of<br/>Clean Energy<br/>Innovation</div>
          </div>
          <div className="absolute -top-6 -right-2 lg:-right-6 bg-emerald-500 text-white rounded-2xl shadow-xl p-4 hidden md:block">
            <Leaf className="w-7 h-7" />
          </div>
        </div>

        <div>
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-emerald-200 bg-emerald-50 text-emerald-700 text-xs font-semibold uppercase tracking-widest">
            <Leaf className="w-3.5 h-3.5" /> About Us
          </div>
          <h2 className="mt-5 text-4xl md:text-5xl font-extrabold leading-tight text-[#0b1a1a]">
            Experience the Next Era of <span className="text-emerald-600">Clean Fuel</span>
          </h2>
          <p className="mt-5 text-slate-600 leading-relaxed text-lg">
            Indian Energreen is leading India's transition to sustainable fuel with advanced BioCNG and Compressed Biogas (CBG) solutions — delivering powerful, efficient, and eco-friendly energy for a better tomorrow.
          </p>

          <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
            {aboutFeatures.map((f) => (
              <div key={f} className="flex items-center gap-2.5">
                <CheckCircle2 className="w-5 h-5 text-emerald-500 shrink-0" />
                <span className="text-slate-700 font-medium">{f}</span>
              </div>
            ))}
          </div>

          <a href="#services" className="mt-8 inline-flex items-center gap-2 bg-[#0b1a1a] hover:bg-emerald-700 text-white px-6 py-3 rounded-full font-semibold transition-colors">
            Learn More <ArrowRight className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default About;
